import { motion } from "framer-motion";
import { FaArrowUp } from "react-icons/fa";

const ringVariants = {
  hover: {
    scale: [0.6, 1.6],
    opacity: [0.5, 0],
    transition: {
      duration: 1.5,
      repeat: Infinity,
      repeatType: "loop",
    },
  },
  rest: { scale: 0, opacity: 0 },
};

const ScrollToTopButton = ({ scrollToTop }) => {
  return (
    <motion.div
      whileHover="hover"
      initial="rest"
      animate="rest"
      className="relative w-10 h-10 mt-4 md:mt-0"
    >
      {/* Gelber Hover-Ring */}
      <motion.div
        variants={ringVariants}
        className="absolute w-full h-full border border-yellow-400 rounded-full z-0 pointer-events-none"
      />

      {/* Klickbarer Button */}
      <button
        onClick={scrollToTop}
        className="bg-gray-800 text-gray-100 rounded-full p-2 shadow-md hover:bg-gray-800 focus:outline-none w-full h-full z-40 relative flex items-center justify-center"
        aria-label="Scroll to top"
      >
        <FaArrowUp size={12} />
      </button>
    </motion.div>
  );
};

export default ScrollToTopButton;
